var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 9H21M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z","stroke":"#000000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CreditCard.defaultProps = {"width":"800px","height":"800px","viewBox":"0 0 24 24","fill":"none"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
